import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import P2pLayout from './P2pLayout';
import './p2p.css';

const P2pCreatePost = () => {
  const navigate = useNavigate();

  // Stepper state
  const [currentStep, setCurrentStep] = useState(1);

  // Step 1: Type & Price State
  const [side, setSide] = useState('buy'); // 'buy' | 'sell'
  const [asset, setAsset] = useState('USDT');
  const [fiat, setFiat] = useState('INR');
  const [priceType, setPriceType] = useState('fixed'); // 'fixed' | 'floating'
  const [fixedPrice, setFixedPrice] = useState(95.25);
  const lowestPrice = 92.00;

  // Step 2: Amount & Payment State
  const [totalAmount, setTotalAmount] = useState('12.00');
  const [minLimit, setMinLimit] = useState('200.00');
  const [maxLimit, setMaxLimit] = useState('2,000,000.00');
  const [timeLimit, setTimeLimit] = useState('15 min');
  const [paymentMethod, setPaymentMethod] = useState('Express UPI');

  // Step 3: Remarks & Auto Response State
  const [termsTag, setTermsTag] = useState('Bank statement required');
  const [remarks, setRemarks] = useState('');
  const [autoReply, setAutoReply] = useState('');
  const [region, setRegion] = useState('All Regions');
  const [condRegistered, setCondRegistered] = useState(false);
  const [condDays, setCondDays] = useState(0);
  const [condHoldings, setCondHoldings] = useState(false);
  const [condBtc, setCondBtc] = useState(0.01);
  const [status, setStatus] = useState('online'); // 'online' | 'offline' | 'private'

  // Step 4: Confirmation Popup
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  // Price decrement / increment handlers
  const handlePriceDec = () => {
    setFixedPrice(prev => Math.max(91.44, parseFloat((prev - 0.05).toFixed(2))));
  };
  const handlePriceInc = () => {
    setFixedPrice(prev => Math.min(109.53, parseFloat((prev + 0.05).toFixed(2))));
  };

  // Stepper navigation
  const handleNext = () => {
    if (currentStep === 1) setCurrentStep(2);
    else if (currentStep === 2) setCurrentStep(3);
    else if (currentStep === 3) setShowConfirmModal(true);
  };

  const handlePrev = () => {
    if (currentStep > 1) setCurrentStep(prev => prev - 1);
  };

  const handleConfirmPost = () => {
    setShowConfirmModal(false);
    setShowSuccessModal(true);
  };

  return (
    <P2pLayout title="Post Normal Ad">
      <div className="p2p-post-ad-page">

        {/* ==================== 1. PAGE HEADER ==================== */}
        <div className="p2p-post-ad-header">
          <h2>Post Normal Ad</h2>
          <p>Create your P2P ad in just a few simple steps</p>
        </div>

        {/* ==================== 2. STEPPER BAR (MATCHING SCREENSHOT) ==================== */}
        <div className="p2p-post-stepper-wrap">
          {/* Step 1 */}
          <div
            className="p2p-stepper-col"
            onClick={() => setCurrentStep(1)}
          >
            <div className="p2p-stepper-node-wrap">
              <div className="p2p-stepper-spacer" />
              <div className={`p2p-stepper-circle ${currentStep >= 1 ? 'gold' : ''}`}>
                {currentStep > 1 ? (
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                ) : (
                  '1'
                )}
              </div>
              <div className="p2p-stepper-line-half">
                <div
                  className="p2p-stepper-line-fill"
                  style={{ width: currentStep === 1 ? '30%' : currentStep > 1 ? '100%' : '0%' }}
                />
              </div>
            </div>
            <div className="p2p-stepper-label">
              <h4>Set Type & Price</h4>
              <p>Choose asset and set your price</p>
            </div>
          </div>

          {/* Step 2 */}
          <div
            className="p2p-stepper-col"
            onClick={() => currentStep >= 2 && setCurrentStep(2)}
          >
            <div className="p2p-stepper-node-wrap">
              <div className="p2p-stepper-line-half">
                <div
                  className="p2p-stepper-line-fill"
                  style={{ width: currentStep >= 2 ? '100%' : '0%' }}
                />
              </div>
              <div className={`p2p-stepper-circle ${currentStep >= 2 ? 'gold' : ''}`}>
                {currentStep > 2 ? (
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                ) : (
                  '2'
                )}
              </div>
              <div className="p2p-stepper-line-half">
                <div
                  className="p2p-stepper-line-fill"
                  style={{ width: currentStep >= 3 ? '100%' : '0%' }}
                />
              </div>
            </div>
            <div className="p2p-stepper-label">
              <h4>Set Total Amount & Payment Method</h4>
              <p>Enter amount and select payment</p>
            </div>
          </div>

          {/* Step 3 */}
          <div
            className="p2p-stepper-col step-3"
            onClick={() => currentStep >= 3 && setCurrentStep(3)}
          >
            <div className="p2p-stepper-node-wrap">
              <div className="p2p-stepper-line-half">
                <div
                  className="p2p-stepper-line-fill"
                  style={{ width: currentStep >= 3 ? '100%' : '0%' }}
                />
              </div>
              <div className="p2p-stepper-circle step-3-circle">
                3
              </div>
              <div className="p2p-stepper-spacer" />
            </div>
            <div className="p2p-stepper-label">
              <h4>Set Remarks & Automatic Response</h4>
              <p>Add remarks and auto reply</p>
            </div>
          </div>
        </div>

        {/* ==================== 3. STEP 3 NOTICE BANNER ==================== */}
        {currentStep === 3 && (
          <div className="p2p-post-notice-box">
            <h4>Please ensure that you comply with P2P rules to avoid account suspension or expulsion from the AGCE Merchant Program.</h4>
            <p>If you require taker's document for verification, it's necessary to indicate the requirement in the 'Remarks' section. Imposing extra fees on takers is not allowed in all scenarios.</p>
          </div>
        )}

        {/* ==================== 4. STEP MAIN FORM CARD ==================== */}
        <div className="p2p-post-form-card">

          {/* ---------------- STEP 1 ---------------- */}
          {currentStep === 1 && (
            <div className="p2p-step-content step-1">

              {/* Buy / Sell Pill Toggle */}
              <div className="p2p-post-pill-toggle">
                <button
                  type="button"
                  className={`p2p-post-toggle-btn ${side === 'buy' ? 'active' : ''}`}
                  onClick={() => setSide('buy')}
                >
                  I want to buy
                </button>
                <button
                  type="button"
                  className={`p2p-post-toggle-btn ${side === 'sell' ? 'active' : ''}`}
                  onClick={() => setSide('sell')}
                >
                  I want to sell
                </button>
              </div>

              {/* Asset & With Fiat Grid */}
              <div className="p2p-post-row two-col">
                <div className="p2p-post-field">
                  <label>Asset</label>
                  <div className="p2p-post-select-box">
                    <span className="p2p-post-coin-icon usdt">T</span>
                    <select value={asset} onChange={e => setAsset(e.target.value)}>
                      <option value="USDT">USDT</option>
                      <option value="BTC">BTC</option>
                      <option value="ETH">ETH</option>
                    </select>
                    <i className="ri-arrow-down-s-line"></i>
                  </div>
                </div>

                <div className="p2p-post-field">
                  <label>
                    With Fiat <i className="ri-information-line p2p-info-icon" title="Select your local fiat currency"></i>
                  </label>
                  <div className="p2p-post-select-box">
                    <span className="p2p-post-coin-icon inr">₹</span>
                    <select value={fiat} onChange={e => setFiat(e.target.value)}>
                      <option value="INR">INR</option>
                      <option value="USD">USD</option>
                      <option value="AED">AED</option>
                      <option value="EUR">EUR</option>
                      <option value="VND">VND</option>
                    </select>
                    <i className="ri-arrow-down-s-line"></i>
                  </div>
                </div>
              </div>

              {/* Price Type Radio Cards */}
              <div className="p2p-post-field">
                <label>Price Type</label>
                <div className="p2p-post-price-type-grid">
                  <div
                    className={`p2p-post-price-card ${priceType === 'fixed' ? 'active' : ''}`}
                    onClick={() => setPriceType('fixed')}
                  >
                    <div className="p2p-post-radio-circle">
                      {priceType === 'fixed' && <div className="p2p-post-radio-dot" />}
                    </div>
                    <span>Fixed Price</span>
                  </div>

                  <div
                    className={`p2p-post-price-card ${priceType === 'floating' ? 'active' : ''}`}
                    onClick={() => setPriceType('floating')}
                  >
                    <div className="p2p-post-radio-circle">
                      {priceType === 'floating' && <div className="p2p-post-radio-dot" />}
                    </div>
                    <span>Floating Price</span>
                  </div>
                </div>
              </div>

              {/* Fixed Price (INR) Stepper */}
              <div className="p2p-post-field">
                <label>Fixed Price ({fiat})</label>
                <div className="p2p-post-stepper-input">
                  <button type="button" className="p2p-post-step-btn dec" onClick={handlePriceDec}>
                    −
                  </button>
                  <input
                    type="number"
                    step="0.01"
                    value={fixedPrice}
                    onChange={e => setFixedPrice(parseFloat(e.target.value) || 0)}
                    className="p2p-post-num-input"
                  />
                  <button type="button" className="p2p-post-step-btn inc" onClick={handlePriceInc}>
                    +
                  </button>
                </div>
                <span className="p2p-post-field-hint">
                  The fixed price should be between 91.44 - 109.53
                </span>
              </div>

              {/* Price Summary Box */}
              <div className="p2p-post-summary-card">
                <div className="p2p-post-summary-col">
                  <span className="p2p-post-summary-label">Your Price</span>
                  <strong className="p2p-post-summary-val">₹ {fixedPrice.toFixed(2)}</strong>
                </div>
                <div className="p2p-post-summary-col">
                  <span className="p2p-post-summary-label">Lowest Order Price</span>
                  <strong className="p2p-post-summary-val">₹ {lowestPrice.toFixed(2)}</strong>
                </div>
              </div>

            </div>
          )}

          {/* ---------------- STEP 2 ---------------- */}
          {currentStep === 2 && (
            <div className="p2p-step-content step-2">

              {/* Buy / Sell Pill Indicator */}
              <div className="p2p-post-pill-toggle">
                <button
                  type="button"
                  className={`p2p-post-toggle-btn ${side === 'buy' ? 'active' : ''}`}
                  onClick={() => setSide('buy')}
                >
                  I want to buy
                </button>
                <button
                  type="button"
                  className={`p2p-post-toggle-btn ${side === 'sell' ? 'active' : ''}`}
                  onClick={() => setSide('sell')}
                >
                  I want to sell
                </button>
              </div>

              {/* Total Amount */}
              <div className="p2p-post-field">
                <label>Total Amount</label>
                <div className="p2p-post-amount-wrap">
                  <input
                    type="text"
                    placeholder="Enter total amount"
                    value={totalAmount}
                    onChange={e => setTotalAmount(e.target.value)}
                  />
                  <span className="p2p-post-amount-curr">{asset}</span>
                  <button
                    type="button"
                    className="p2p-post-amount-all"
                    onClick={() => setTotalAmount('12.00')}
                  >
                    All
                  </button>
                </div>
                <div className="p2p-post-amount-subtext">
                  <span>≈ {(parseFloat(totalAmount || 0) * fixedPrice).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {fiat}</span>
                  <span className="p2p-post-avail">Available: 0.1{asset} <i className="ri-add-circle-line"></i></span>
                </div>
              </div>

              {/* Order Limit */}
              <div className="p2p-post-field">
                <label>Order Limit</label>
                <div className="p2p-post-limits-row">
                  <div className="p2p-post-limit-box">
                    <span className="p2p-post-limit-label">Minimum ({fiat})</span>
                    <input
                      type="text"
                      value={minLimit}
                      onChange={e => setMinLimit(e.target.value)}
                    />
                    <small className="p2p-post-limit-hint">
                      ≈ {(parseFloat(minLimit.replace(/,/g, '') || 0) / fixedPrice).toFixed(2)} {asset}
                    </small>
                  </div>

                  <span className="p2p-post-limit-sep">~</span>

                  <div className="p2p-post-limit-box">
                    <span className="p2p-post-limit-label">Maximum ({fiat})</span>
                    <input
                      type="text"
                      value={maxLimit}
                      onChange={e => setMaxLimit(e.target.value)}
                    />
                    <small className="p2p-post-limit-hint">
                      ≈ {(parseFloat(maxLimit.replace(/,/g, '') || 0) / fixedPrice).toFixed(2)} {asset}
                    </small>
                  </div>
                </div>
              </div>

              {/* Payment Time Limit */}
              <div className="p2p-post-field">
                <label>Payment Time Limit</label>
                <div className="p2p-post-select-box">
                  <i className="ri-time-line p2p-time-icon"></i>
                  <select value={timeLimit} onChange={e => setTimeLimit(e.target.value)}>
                    <option value="15 min">15 min</option>
                    <option value="30 min">30 min</option>
                    <option value="45 min">45 min</option>
                    <option value="60 min">60 min</option>
                  </select>
                  <i className="ri-arrow-down-s-line"></i>
                </div>
              </div>

              {/* Payment Method */}
              <div className="p2p-post-field">
                <label>Payment Method</label>
                <div className="p2p-post-select-box">
                  <i className="ri-bank-card-line p2p-time-icon"></i>
                  <select value={paymentMethod} onChange={e => setPaymentMethod(e.target.value)}>
                    <option value="Express UPI">Express UPI</option>
                    <option value="Bank Transfer">Bank Transfer</option>
                    <option value="IMPS">IMPS</option>
                    <option value="Paytm">Paytm</option>
                  </select>
                  <i className="ri-arrow-down-s-line"></i>
                </div>
              </div>

            </div>
          )}

          {/* ---------------- STEP 3 ---------------- */}
          {currentStep === 3 && (
            <div className="p2p-step-content step-3">

              {/* Terms Tags (Optional) */}
              <div className="p2p-post-field">
                <label>Terms Tags (Optional)</label>
                <div className="p2p-post-select-box">
                  <select value={termsTag} onChange={e => setTermsTag(e.target.value)}>
                    <option value="Select up to 3 tags">Select up to 3 tags</option>
                    <option value="Bank statement required">Bank statement required</option>
                    <option value="No third party payment">No third party payment</option>
                    <option value="Fast payment only">Fast payment only</option>
                    <option value="KYC verified users only">KYC verified users only</option>
                  </select>
                  <i className="ri-arrow-down-s-line"></i>
                </div>
              </div>

              {/* Remarks (Optional) */}
              <div className="p2p-post-field">
                <label>Remarks (Optional)</label>
                <div className="p2p-post-textarea-wrap">
                  <textarea
                    placeholder="Write your remarks here... (e.g. No crypto related words like BTC, USDT, ETH etc.)"
                    maxLength={1000}
                    value={remarks}
                    onChange={e => setRemarks(e.target.value)}
                  />
                  <span className="p2p-post-char-count">{remarks.length}/1000</span>
                </div>
              </div>

              {/* Auto Reply (Optional) */}
              <div className="p2p-post-field">
                <label>Auto Reply (Optional)</label>
                <div className="p2p-post-textarea-wrap">
                  <textarea
                    placeholder="Auto reply message will be sent to the counterparty once the order is created"
                    maxLength={1000}
                    value={autoReply}
                    onChange={e => setAutoReply(e.target.value)}
                  />
                  <span className="p2p-post-char-count">{autoReply.length}/1000</span>
                </div>
              </div>

              {/* Display Region & Counterparty Conditions */}
              <div className="p2p-post-row two-col">
                <div className="p2p-post-field">
                  <label>
                    Display to users in <i className="ri-information-line p2p-info-icon"></i>
                  </label>
                  <div className="p2p-post-select-box">
                    <select value={region} onChange={e => setRegion(e.target.value)}>
                      <option value="All Regions">All Regions</option>
                      <option value="India">India</option>
                      <option value="UAE">UAE</option>
                      <option value="Vietnam">Vietnam</option>
                      <option value="United States">United States</option>
                    </select>
                    <i className="ri-arrow-down-s-line"></i>
                  </div>
                </div>

                <div className="p2p-post-field">
                  <label>Counterparty Conditions</label>
                  <div className="p2p-post-conditions-list">
                    <label className="p2p-post-checkbox-item">
                      <input
                        type="checkbox"
                        checked={condRegistered}
                        onChange={e => setCondRegistered(e.target.checked)}
                      />
                      <span>Registered</span>
                      <input
                        type="number"
                        className="p2p-post-inline-num"
                        value={condDays}
                        onChange={e => setCondDays(parseInt(e.target.value) || 0)}
                      />
                      <span>day(s) ago</span>
                    </label>

                    <label className="p2p-post-checkbox-item">
                      <input
                        type="checkbox"
                        checked={condHoldings}
                        onChange={e => setCondHoldings(e.target.checked)}
                      />
                      <span>Holdings more than</span>
                      <input
                        type="number"
                        step="0.01"
                        className="p2p-post-inline-num"
                        value={condBtc}
                        onChange={e => setCondBtc(parseFloat(e.target.value) || 0)}
                      />
                      <span>BTC</span>
                    </label>
                  </div>
                </div>
              </div>

              {/* Status Radio Cards */}
              <div className="p2p-post-field">
                <label>Status</label>
                <div className="p2p-post-status-grid">
                  <div
                    className={`p2p-post-status-card ${status === 'online' ? 'active' : ''}`}
                    onClick={() => setStatus('online')}
                  >
                    <div className="p2p-post-status-head">
                      <div className="p2p-post-radio-circle">
                        {status === 'online' && <div className="p2p-post-radio-dot" />}
                      </div>
                      <span className="p2p-post-status-dot online">●</span>
                      <strong>Online</strong>
                    </div>
                    <p>Ad will be visible and active for buyers</p>
                  </div>

                  <div
                    className={`p2p-post-status-card ${status === 'offline' ? 'active' : ''}`}
                    onClick={() => setStatus('offline')}
                  >
                    <div className="p2p-post-status-head">
                      <div className="p2p-post-radio-circle">
                        {status === 'offline' && <div className="p2p-post-radio-dot" />}
                      </div>
                      <span className="p2p-post-status-dot offline">●</span>
                      <strong>Offline</strong>
                    </div>
                    <p>Ad will be hidden temporarily</p>
                  </div>

                  <div
                    className={`p2p-post-status-card ${status === 'private' ? 'active' : ''}`}
                    onClick={() => setStatus('private')}
                  >
                    <div className="p2p-post-status-head">
                      <div className="p2p-post-radio-circle">
                        {status === 'private' && <div className="p2p-post-radio-dot" />}
                      </div>
                      <span className="p2p-post-status-dot private">●</span>
                      <strong>Private <i className="ri-information-line"></i></strong>
                    </div>
                    <p>Only via direct link</p>
                  </div>
                </div>
              </div>

            </div>
          )}

        </div>

        {/* ==================== 5. BOTTOM HELP STRIP (STEP 1 ONLY) ==================== */}
        {currentStep === 1 && (
          <div className="p2p-post-help-strip">
            <div className="p2p-post-help-left">
              <strong>Need help?</strong>
              <span>Read our P2P ad guide to create successful ads.</span>
            </div>
            <a href="#guide" className="p2p-post-guide-link">View Guide</a>
          </div>
        )}

        {/* ==================== 6. BOTTOM ACTION BAR ==================== */}
        <div className="p2p-post-bottom-bar">
          <div className="p2p-post-fee-note">
            {currentStep > 1 && (
              <span>Reserved Fee <i className="ri-information-line"></i> <strong>-- {asset}</strong></span>
            )}
          </div>

          <div className="p2p-post-action-btns">
            {currentStep === 1 ? (
              <button
                type="button"
                className="p2p-post-cancel-btn"
                onClick={() => navigate('/p2p-dashboard')}
              >
                Cancel
              </button>
            ) : (
              <button
                type="button"
                className="p2p-post-prev-btn"
                onClick={handlePrev}
              >
                Previous
              </button>
            )}

            <button
              type="button"
              className="p2p-post-next-btn"
              onClick={handleNext}
            >
              Next
            </button>
          </div>
        </div>

      </div>

      {/* ==================== 7. CONFIRM TO POST MODAL (SCREENSHOT 4) ==================== */}
      {showConfirmModal && typeof document !== 'undefined' && createPortal(
        <div className="p2p-modal-overlay" style={{ zIndex: 1000000000 }} onClick={() => setShowConfirmModal(false)}>
          <div className="p2p-post-confirm-modal" onClick={e => e.stopPropagation()}>
            {/* Header */}
            <div className="p2p-pcm-header">
              <div className="p2p-pcm-title-wrap">
                <h3>Confirm to Post</h3>
                <p>Please review your ad details carefully before posting.</p>
              </div>
              <button
                type="button"
                className="p2p-pcm-close-btn"
                onClick={() => setShowConfirmModal(false)}
              >
                <i className="ri-close-line"></i>
              </button>
            </div>

            {/* Body Review Table */}
            <div className="p2p-pcm-body">
              <div className="p2p-pcm-row">
                <span className="p2p-pcm-label">Type</span>
                <strong className={`p2p-pcm-val ${side === 'buy' ? 'text-green' : 'text-red'}`}>
                  {side === 'buy' ? 'Buy' : 'Sell'}
                </strong>
              </div>

              <div className="p2p-pcm-row">
                <span className="p2p-pcm-label">Asset</span>
                <strong className="p2p-pcm-val">{asset}</strong>
              </div>

              <div className="p2p-pcm-row">
                <span className="p2p-pcm-label">Currency</span>
                <strong className="p2p-pcm-val">{fiat}</strong>
              </div>

              <div className="p2p-pcm-row">
                <span className="p2p-pcm-label">Price Type</span>
                <strong className="p2p-pcm-val">{priceType === 'fixed' ? 'Fixed' : 'Floating'}</strong>
              </div>

              <div className="p2p-pcm-row">
                <span className="p2p-pcm-label">Price</span>
                <strong className="p2p-pcm-val">{fixedPrice.toFixed(2)} {fiat}</strong>
              </div>

              <div className="p2p-pcm-row">
                <span className="p2p-pcm-label">Order Limit</span>
                <strong className="p2p-pcm-val">{minLimit} {fiat} ~ {maxLimit} {fiat}</strong>
              </div>

              <div className="p2p-pcm-row">
                <span className="p2p-pcm-label">Total Trading Amount</span>
                <strong className="p2p-pcm-val">{totalAmount} {asset}</strong>
              </div>

              <div className="p2p-pcm-row solid-divider">
                <span className="p2p-pcm-label">Estimated Fee</span>
                <strong className="p2p-pcm-val">0.01 {asset}</strong>
              </div>

              <div className="p2p-pcm-row">
                <span className="p2p-pcm-label">Payment Method</span>
                <strong className="p2p-pcm-val">{paymentMethod}</strong>
              </div>

              <div className="p2p-pcm-row">
                <span className="p2p-pcm-label">Payment Time Limit</span>
                <strong className="p2p-pcm-val">{timeLimit}</strong>
              </div>

              <div className="p2p-pcm-row">
                <span className="p2p-pcm-label">Available Region(s)</span>
                <strong className="p2p-pcm-val">{region}</strong>
              </div>

              <div className="p2p-pcm-row">
                <span className="p2p-pcm-label">Terms Tags</span>
                <strong className="p2p-pcm-val">{termsTag}</strong>
              </div>

              <div className="p2p-pcm-row">
                <span className="p2p-pcm-label">Status</span>
                <span className="p2p-pcm-status-pill online">
                  ● {status === 'online' ? 'Online' : status === 'offline' ? 'Offline' : 'Private'}
                </span>
              </div>
            </div>

            {/* Footer */}
            <div className="p2p-pcm-footer">
              <button
                type="button"
                className="p2p-pcm-cancel-btn"
                onClick={() => setShowConfirmModal(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="p2p-pcm-submit-btn"
                onClick={handleConfirmPost}
              >
                Confirm to post
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}

      {/* ==================== 8. POST SUCCESSFUL MODAL ==================== */}
      {showSuccessModal && typeof document !== 'undefined' && createPortal(
        <div className="p2p-modal-overlay" style={{ zIndex: 1000000000 }} onClick={() => setShowSuccessModal(false)}>
          <div className="p2p-post-confirm-modal p2p-post-success-modal" onClick={e => e.stopPropagation()}>
            {/* Header */}
            <div className="p2p-pcm-header border-0">
              <div className="p2p-pcm-title-wrap">
                {/* <h3>Successful</h3>
                <p>Your ad has been successfully posted to the marketplace.</p> */}
              </div>
              <button
                type="button"
                className="p2p-pcm-close-btn"
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate('/p2p-my-ads');
                }}
              >
                <i className="ri-close-line"></i>
              </button>
            </div>

            {/* Body */}
            <div className="p2p-pcm-body p2p-psm-body">
              {/* Thumbs-up Vector */}
              <div className="p2p-psm-thumb-wrap">
                <div className="p2p-psm-thumb-circle">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7 22H4C3.46957 22 2.96086 21.7893 2.58579 21.4142C2.21071 21.0391 2 20.5304 2 20V13C2 12.4696 2.21071 11.9609 2.58579 11.5858C2.96086 11.2107 3.46957 11 4 11H7M14 9V5C14 4.20435 13.6839 3.44129 13.1213 2.87868C12.5587 2.31607 11.7956 2 11 2L7 11V22H18.28C18.7623 22.0055 19.2304 21.8364 19.5979 21.524C19.9654 21.2116 20.2078 20.776 20.28 20.3L21.66 11.3C21.7035 11.0134 21.6842 10.7207 21.6033 10.4423C21.5225 10.1638 21.3821 9.90626 21.192 9.68744C21.0018 9.46862 20.7664 9.29367 20.5022 9.17482C20.238 9.05597 19.9511 8.99596 19.66 9H14Z"
                      fill="#10B981"
                      stroke="#059669"
                      strokeWidth="1.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <h4 className="p2p-psm-headline">Ad Published Successfully!</h4>
                <p className="p2p-psm-subheadline">
                  Your <strong className={side === 'buy' ? 'text-green' : 'text-red'}>{side.toUpperCase()}</strong> ad for <strong>{totalAmount} {asset}</strong> at <strong>{fixedPrice.toFixed(2)} {fiat}</strong> is now live.
                </p>
              </div>

              {/* Summary Details */}
              <div className="p2p-psm-summary-card">
                <div className="p2p-pcm-row">
                  <span className="p2p-pcm-label">Type</span>
                  <strong className={`p2p-pcm-val ${side === 'buy' ? 'text-green' : 'text-red'}`}>
                    {side === 'buy' ? 'Buy' : 'Sell'}
                  </strong>
                </div>

                <div className="p2p-pcm-row">
                  <span className="p2p-pcm-label">Asset</span>
                  <strong className="p2p-pcm-val">{asset}</strong>
                </div>

                <div className="p2p-pcm-row">
                  <span className="p2p-pcm-label">Price</span>
                  <strong className="p2p-pcm-val">{fixedPrice.toFixed(2)} {fiat}</strong>
                </div>

                <div className="p2p-pcm-row">
                  <span className="p2p-pcm-label">Total Amount</span>
                  <strong className="p2p-pcm-val">{totalAmount} {asset}</strong>
                </div>

                <div className="p2p-pcm-row">
                  <span className="p2p-pcm-label">Payment Method</span>
                  <strong className="p2p-pcm-val">{paymentMethod}</strong>
                </div>

                <div className="p2p-pcm-row">
                  <span className="p2p-pcm-label">Status</span>
                  <span className="p2p-pcm-status-pill online">
                    ● Online
                  </span>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="p2p-pcm-footer">
              <button
                type="button"
                className="p2p-pcm-cancel-btn"
                onClick={() => {
                  setShowSuccessModal(false);
                  setCurrentStep(1);
                }}
              >
                Post Another Ad
              </button>
              <button
                type="button"
                className="p2p-pcm-submit-btn"
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate('/p2p-my-ads');
                }}
              >
                View My Ads
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}

    </P2pLayout>
  );
};

export default P2pCreatePost;
